import React from "react";
import {endOfMonth, addYears, format, isBefore} from "date-fns";

export const YEARS_OFFSETS: number[] = [0, 1, 2, 3, 4];

const dateOfEntryMap =
    (yearOffset: number) =>
    (month: number): Date =>
        endOfMonth(addYears(new Date(new Date().getFullYear(), month - 1), yearOffset));

const dateOptionMap = (date: Date): JSX.Element => (
    <option key={format(date, "yyyy-MM")} value={format(date, "yyyy-MM")}>
        {format(date, "MMMM yyyy")}
    </option>
);

export const entryMonthOptions = (entryMonths: number[]): JSX.Element[] =>
    YEARS_OFFSETS.map((yearOffset) => {
        const yearOptions = entryMonths
            .map(dateOfEntryMap(yearOffset))
            .filter((date) => isBefore(new Date(), date))
            .map(dateOptionMap);

        return (
            !!yearOptions.length && (
                <optgroup key={yearOffset} label={format(addYears(new Date(), yearOffset), "yyyy")}>
                    {yearOptions}
                </optgroup>
            )
        );
    });
